module.exports = __webpack_public_path__ + "static/media/deductibleZ.4d0e35ec.png";